import { createContext, useState, useContext, useEffect } from 'react'
import { useAuth } from './AuthProvider'
import {
    GetCustomerCreditInfo, AddTaskForSendPriceList, SendPriceListViaEmail, GetDeliveryAddresses, AddDeliveryAddress, GetPeopleAuthorizedToCollectDelivery,
    AddPersonAuthorizedToCollectDelivery, AddTaskForSendPriceListNow,
    DeletePersonAuthorizedToCollectDelivery,
    DeleteDeliveryAddress,
    UpdatePersonAuthorizedToCollectDelivery,
    SetDeliveryAddressAsMain,
    UpdateDeliveryAddress,
    AddPersonAuthorizedToReceiveEInvoices,
    GetCustomersWithActiveBasket,
} from '../Services/CustomerService'

import { toast } from 'react-toastify'
import { useConfig } from './ConfigProvider';
import axios from 'axios';

export const CustomerContext = createContext()

export const useCustomer = () => {
    return useContext(CustomerContext);
};

export const CustomerProvider = ({ children }) => {
    const { authState, logout } = useAuth()
    const { api } = useConfig()

    const [creditInfo, setCreditInfo] = useState({
        totalDocAmount: 0.0,
        totalDocUnpaid: 0.0,
        totalDispAmount: 0.0,
        totalOrderAmount: 0.0,
        grantCredit: 0.0,
        remainCredit: 0.0,
    })

    const [addresses, setAddress] = useState([])//authState.user ? authState.user.deliveryPlaces : []
    const [addressesWithoutMain, setAddressesWithoutMain] = useState([])
    const [authorizedPersons, setAuthorizedPersons] = useState([])//authState.user ? authState.user.deliveryUsers : []
    const [isLoadingAddresses, setIsLoadingAddresses] = useState(false);
    const [isLoadingAddressesWithoutMain, setIsLoadingAddressesWithoutMain] = useState(false);
    const [isLoadingAuthorized, setIsLoadingAuthorized] = useState(false);
    const [isLoadingCredit, setIsLoadingCredit] = useState(false);
    const [contractorsWithSavedBasket, setContractorsWithSavedBasket] = useState([])

    useEffect(() => {
        if (authState.custId && authState.custId !== '' && authState.custId !== ' ') {
            handleGetDeliveryAddresses(true)
            handleGetPeopleAuthorizedToCollectDelivery()
        }
    }, [api, authState.custId])

    useEffect(() => {
        handleGetCreditInfo()
    }, [authState, authState.selectedCustomerData])

    useEffect(() => {
        if (authState && authState.user) {
            const source = axios.CancelToken.source()
            handleGetContractorsWithSavedBasket(source.token)
            return () => {
                source.cancel()
            }
        }
    }, [authState.selectedCustomerTax])

    const handleGetContractorsWithSavedBasket = (cancelToken) => {
        GetCustomersWithActiveBasket(api, cancelToken).then(res => {
            setContractorsWithSavedBasket(res.data)
        }).catch(e => {
            console.log(e)
            setContractorsWithSavedBasket([])
        })
    }

    const handleGetDeliveryAddresses = (addMainCompanyAddress) => {
        if (addMainCompanyAddress) {
            setIsLoadingAddresses(true)
        } else {
            setIsLoadingAddressesWithoutMain(true)
        }
        GetDeliveryAddresses(api, authState.custId, addMainCompanyAddress).then(res => {
            if (addMainCompanyAddress) {
                setAddress(res.data)
                setIsLoadingAddresses(false)
            } else {
                setAddressesWithoutMain(res.data)
                setIsLoadingAddressesWithoutMain(false)
            }
        }).catch(e => {
            console.log(e)
            if (addMainCompanyAddress) {
                setIsLoadingAddresses(false)
                setAddress([])
            } else {
                setIsLoadingAddressesWithoutMain(false)
                setAddressesWithoutMain([])
            }
            if (e.response.status === 403) {
                if (e.response.data.includes('Brak uprawnień')) {
                    toast.error('Brak uprawnień!')
                }
                else {
                    logout(false, false)
                }
            }
        })
    }
    const handleGetPeopleAuthorizedToCollectDelivery = () => {
        setIsLoadingAuthorized(true)
        GetPeopleAuthorizedToCollectDelivery(api, authState.custId).then(res => {
            setIsLoadingAuthorized(false)
            setAuthorizedPersons(res.data)
        }).catch(e => {
            console.log(e)
            setIsLoadingAuthorized(false)
            setAuthorizedPersons([])
            if (e.response.status === 403) {
                if (e.response.data.includes('Brak uprawnień')) {
                    toast.error('Brak uprawnień!')
                }
                else {
                    logout(false, false)
                }
            }
        })
    }
    const handleAddTaskForSendPriceList = async (custId) => {
        try {
            const res = await AddTaskForSendPriceList(api, custId)
            return true
        } catch (error) {
            console.log(error)
            return false
        }
    }
    const handleAddTaskForSendPriceListNow = async (custId) => {
        try {
            const res = await AddTaskForSendPriceListNow(api, custId)
            return res.data
        } catch (error) {
            console.log(error)
            return false
        }
    }
    const handleSendPriceListViaEmail = async (productFilter) => {
        try {
            const res = SendPriceListViaEmail(api, productFilter)
            return true
        } catch (error) {
            console.log(error)
            return false
        }
    }

    const addDeliveryAddress = async (id, name, zipCode, city, street, phoneNumber, email, expirationDate) => {
        try {
            const res = await AddDeliveryAddress(api, id, name, zipCode, city, street, phoneNumber, email, expirationDate)
            return res.data
        } catch (error) {
            console.log(error)
            if (error.response.status === 403) {
                if (error.response.data.includes('Brak uprawnień')) {
                    toast.error('Brak uprawnień!')
                }
                else {
                    logout(false, false)
                }
            }
            return false
        }
    }

    const updateDeliveryAddress = async (id, name, zipCode, city, street, phoneNumber, email, expirationDate, recNo) => {
        try {
            const res = await UpdateDeliveryAddress(api, id, name, zipCode, city, street, phoneNumber, email, expirationDate, recNo)
            return res.data
        } catch (error) {
            console.log(error)
            if (error.response.status === 403) {
                if (error.response.data.includes('Brak uprawnień')) {
                    toast.error('Brak uprawnień!')
                }
                else {
                    logout(false, false)
                }
            }
            return false
        }
    }

    const deleteDeliveryAddress = async (recNo) => {
        try {
            await DeleteDeliveryAddress(api, recNo)
            return true
        } catch (error) {
            console.log(error)
            if (error.response.status === 403) {
                if (error.response.data.includes('Brak uprawnień')) {
                    toast.error('Brak uprawnień!')
                }
                else {
                    logout(false, false)
                }
            }
            return false
        }
    }

    const setDeliveryAddressAsMain = async (recNo) => {
        try {
            await SetDeliveryAddressAsMain(api, recNo)
            return true
        } catch (error) {
            console.log(error)
            if (error.response.status === 403) {
                if (error.response.data.includes('Brak uprawnień')) {
                    toast.error('Brak uprawnień!')
                }
                else {
                    logout(false, false)
                }
            }
            return false
        }
    }

    const addPersonAuthorizedToCollectDelivery = async (custId, name, surname, position, phoneNumber, email, expirationDate) => {
        try {
            const res = await AddPersonAuthorizedToCollectDelivery(api, custId, name, surname, position, phoneNumber, email, expirationDate)
            return res.data
        } catch (error) {
            console.log(error)
            if (error.response.status === 403) {
                if (error.response.data.includes('Brak uprawnień')) {
                    toast.error('Brak uprawnień!')
                }
                else {
                    logout(false, false)
                }
            }
            return false
        }
    }

    const updatePersonAuthorizedToCollectDelivery = async (custId, name, surname, position, phoneNumber, email, recNo, expirationDate) => {
        try {
            await UpdatePersonAuthorizedToCollectDelivery(api, custId, name, surname, position, phoneNumber, email, recNo, expirationDate)
            return true
        } catch (error) {
            console.log(error)
            if (error.response.status === 403) {
                if (error.response.data.includes('Brak uprawnień')) {
                    toast.error('Brak uprawnień!')
                }
                else {
                    logout(false, false)
                }
            }
            return false
        }
    }

    const deletePersonAuthorizedToCollectDelivery = async (recNo) => {
        try {
            await DeletePersonAuthorizedToCollectDelivery(api, recNo)
            return true
        } catch (error) {
            console.log(error)
            if (error.response.status === 403) {
                if (error.response.data.includes('Brak uprawnień')) {
                    toast.error('Brak uprawnień!')
                }
                else {
                    logout(false, false)
                }
            }
            return false
        }
    }

    const clearTemporaryAddressAndAuthorizedPerson = () => {
        setAddress(prev => [
            ...prev.filter(a => a.id !== '999999')
        ])
        setAuthorizedPersons(prev => [
            ...prev.filter(x => x.custId !== '999999'),
        ])
    }

    const handleAddPersonAuthorizedToReceiveEInvoices = async (email) => {
        try {
            const res = await AddPersonAuthorizedToReceiveEInvoices(api, email, authState.custId)
            return res ? true : false
        } catch (error) {
            return false
        }
    }

    const handleGetCreditInfo = async () => {
        try {
            if (authState.custId && authState.siteId) {
                const tmpTax = (authState.user.customerInfo && authState.user.customerInfo.length > 0) ? authState.user.customerInfo[0].nip : authState.selectedCustomerTax
                setIsLoadingCredit(true)
                const res = await GetCustomerCreditInfo(api, authState.custId, tmpTax.replaceAll('-', ''), authState.siteId)
                setIsLoadingCredit(false)
                setCreditInfo(res.data)
                return res.data
            }
        } catch (e) {
            setIsLoadingCredit(false)
            if (e.response.status === 403) {
                if (e.response.data.includes('Brak uprawnień')) {
                    toast.error('Brak uprawnień!')
                }
                else {
                    logout(false, false)
                }
            }
            console.log(e)
        }
        return null
    }

    useEffect(() => {
        handleGetCreditInfo();
    }, [authState, authState.selectedCustomerData])

    return (
        <CustomerContext.Provider value={{
            creditInfo,
            addresses,
            authorizedPersons,
            isLoadingAddresses,
            isLoadingAuthorized,
            addressesWithoutMain,
            isLoadingAddressesWithoutMain,
            isLoadingCredit,
            contractorsWithSavedBasket,
            handleAddTaskForSendPriceList,
            handleSendPriceListViaEmail,
            addDeliveryAddress,
            addPersonAuthorizedToCollectDelivery,
            handleGetDeliveryAddresses,
            handleGetPeopleAuthorizedToCollectDelivery,
            deleteDeliveryAddress,
            deletePersonAuthorizedToCollectDelivery,
            handleAddTaskForSendPriceListNow,
            handleGetCreditInfo,
            updatePersonAuthorizedToCollectDelivery,
            updateDeliveryAddress,
            setDeliveryAddressAsMain,
            setAddress,
            setAuthorizedPersons,
            clearTemporaryAddressAndAuthorizedPerson,
            handleAddPersonAuthorizedToReceiveEInvoices,
            handleGetCreditInfo,
        }}>
            {children}
        </CustomerContext.Provider>
    )
}